<style lang="scss">
	#on-center {
		.ant-form-item-label {
			margin-top: 1.5rem;
		}
	}

	#handitemedit1 {

		.ant-row,
		.ant-calendar-picker {
			width: 100%;
		}

		.ant-form-item-label {
			width: 15% !important;
		}

		.ant-form-item-control-wrapper {
			width: 70% !important;

			.wart-t {
				width: 100%;
			}
		}

		.ant-calendar-picker-input {
			width: 100%;
		}

		.myright {
			.ant-form-item-label {
				width: 30% !important;
				padding-left: 3.5%;
			}
		}

		.warp_long {
			width: 50%;
			display: inline-block;

			.ant-form-item-label {
				width: 30% !important;
			}

			.ant-form-item-control-wrapper {
				width: 60% !important;

			}
		}

		.texright {
			text-align: right;
			// margin-left: 4%;
		}
	}
</style>

<template>
	<div id='handitemedit1'>
		<div class="tabelMoreFzView main-mybody">
			<div class="tabelMoreFzViewIn">
				<a-form-model ref='ruleForm' :model="form" labelAlign='left' layout="inline" :rules='rules'
					hideRequiredMark>
					<a-row>
						<a-col :span='12'>
							<a-form-model-item label="公司名稱" prop='cn_planned_company_name_cn'>
								<a-input v-model="form.cn_planned_company_name_cn" class='wart-t' @blur='handcn'
								 :disabled='ipoAduitAdmin'/>
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Company Name" prop='cn_planned_company_name_en'>
								<a-input v-model="form.cn_planned_company_name_en" class='wart-t' 
								@input="form.cn_planned_company_name_en=form.cn_planned_company_name_en.replace(/[\u4e00-\u9fa5]/g,'')" 
								:disabled='ipoAduitAdmin'/>
								<!-- @blur='handen' 
								 onkeyup="value=value.replace(/[^a-z A-Z]/g,'')"
								  onafterpaste="value=value.replace(/[^a-z A-Z]/g,'')"-->
								  <!-- @input="form.cn_planned_company_name_en=form.cn_planned_company_name_en.replace(/[^a-z A-Z]/g,'')"  -->
							</a-form-model-item>
						</a-col>

						<a-col :span='12'>
							<a-form-model-item label="上市行業" prop='cn_planned_industry_name_cn'>
								<!-- <Situationall id="industryscn" v-model="form.cn_planned_industry_name_cn" :url='$api.getParamList' "
									:openfirst='form.cn_planned_industry_name_cn&&england == "cn"'
									:disabled='ipoAduitAdmin'
									:valonce='JSON.parse(JSON.stringify(form)).cn_planned_industry_name_cn'
									:params='{"type":"industrys","cn_planned_industry_name_en":form.cn_planned_industry_name_en}'
									:style='"width: 100%;"'>
								</Situationall> -->
								<a-select v-model="form.cn_planned_industry_name_cn" allowClear @select="industryCNChanged">
									<a-select-option v-for="item in industryArr" :key="item.id" :value="item.industry">
										{{item.industry}}
									</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Business Nature" prop='cn_planned_industry_name_en'>
								<!-- <Situationall v-model="form.cn_planned_industry_name_en" :url='$api.getParamList'
									:openfirst='form.cn_planned_industry_name_cn&&england == "en"'
									:disabled='ipoAduitAdmin'
									:valonce='JSON.parse(JSON.stringify(form)).cn_planned_industry_name_en'
									:params='{"type":"industrys","cn_planned_industry_name_cn":form.cn_planned_industry_name_cn}'
									:style='"width: 100%;"
									'>
								</Situationall> -->
								<a-select v-model="form.cn_planned_industry_name_en" allowClear @select="industryENChanged">
									<a-select-option v-for="item in industryArr" :key="item.id" :value="item.industry_en">
										{{item.industry_en}}
									</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label="上市板塊" prop='plates_cn'>
								<a-select v-model="form.plates_cn" class='warp_width' :disabled='ipoAduitAdmin'>
									<a-select-option v-for="(item) in admintypeArrs" :key="item.key+'a'"
										:value="item.value">{{item.text}}</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Market" prop='plates_cn'>
								<a-select v-model="form.plates_cn" class='warp_width' :disabled='ipoAduitAdmin'>
									<a-select-option v-for="(item) in admintypeArrs" :key="item.key+'a'"
										:value="item.value">{{item.entext}}</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label="上市狀態" prop='status_cn'>
								<a-select v-model="form.status_cn" class='warp_width' :disabled='ipoAduitAdmin'
									@change='handselefn(form.status_cn,"ruleForm")'>
									<a-select-option v-for="(item) in admintypeArr" :key="item.key + 'b'"
										:value="item.value">{{item.text}}</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Listing Status" prop='status_cn'>
								<a-select v-model="form.status_cn" class='warp_width' :disabled='ipoAduitAdmin'
									@change='handselefn(form.status_cn,"ruleForm")'>
									<a-select-option v-for="(item) in admintypeArr" :key="item.key + 'b'"
										:value="item.value">{{item.entext}}</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label="遞表日期" prop='delivery_date'>
								<a-date-picker v-model="form.delivery_date" @change="handback('delivery_date')"
								:disabled='ipoAduitAdmin'
									:disabled-date="deliveryDate" class='warp_width' placeholder="" />
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Submission Date" prop='delivery_date'>
								<a-date-picker v-model="form.delivery_date" @change="handback('delivery_date')"
								:disabled='ipoAduitAdmin'
									:disabled-date="deliveryDate" class='warp_width' placeholder="" />
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<div id='on-center'>
								<a-form-model-item label="公司業務" prop='info'>
									<a-textarea v-model="form.info" :auto-size="{ minRows: 4, maxRows: 5 }"
										:maxLength='200' :disabled-date="deliveryDate" class='wart-t'
										:disabled='ipoAduitAdmin'
										@blur='handkong' />
									<span
										style="color:#bfbfbf;position:absolute;bottom:-10px;right:10px;">{{form.info.length}}/200</span>
								</a-form-model-item>
							</div>
						</a-col>
						<a-col :span='12' class='myright'>
							<div id='on-center'>
								<a-form-model-item label="Company Profile" prop='info_en'>
									<a-textarea v-model="form.info_en" :auto-size="{ minRows: 4, maxRows: 5 }"
										:maxLength='200' :disabled-date="deliveryDate" class='wart-t'
										:disabled='ipoAduitAdmin'
										@input="form.info_en=form.info_en.replace(/[\u4e00-\u9fa5]/g,'')"
										 />
										<!-- @input="form.info_en=form.info_en.replace(/[^a-z A-Z]/g,'')"  -->
									<span
										style="color:#bfbfbf;position:absolute;bottom:-10px;right:10px;">{{form.info_en.length}}/200</span>
								</a-form-model-item>
							</div>
						</a-col>
					</a-row>
					<!-- <div class='warp_long'></div> -->
					<!-- <div class='warp_long texright'>
										<a-form-model-item label="Business Nature"
											prop='cn_planned_industry_name_en'>
											<Situationall v-model="form.cn_planned_industry_name_en"
												:url='$api.getParamList' :openfirst='form.cn_planned_industry_name_cn&&england == "en"'
												:valonce='JSON.parse(JSON.stringify(form)).cn_planned_industry_name_en'
												:params='{"type":"industrys","cn_planned_industry_name_cn":form.cn_planned_industry_name_cn}'
												:style='"width: 100%;"'>
											</Situationall>
										</a-form-model-item>
										</div> -->
				</a-form-model>
			</div>
		</div>
		<div v-if='ipoAduitAdmin'>
			<div  class='warp_daochu' >
				<div style="padding-left: .5rem;" :style='{width:!shKhadmin1Bol? "34rem":"34.5rem"}'>
					<a-textarea v-model='remark' placeholder=" " allow-clear style='width: 100%;' />
				</div>
				<div>
					<div style="padding: .35rem 0;" v-if="$store.state.rolesdata.indexOf('khadmin1') >= 0">
						<button class='btn1' v-if='!shKhadmin1Bol' @click='shTgEvent(record,"2")'
							style="background-color: #ed4849;">審核拒絕</button>
						<button class='btn1 btnx' @click='shTgEvent(record , 1)'>{{shKhadmin1Bol ? '已處理' :'審核通過'}}</button>
					</div>
					<div style="padding: .35rem 0;" v-else>
						<button class='btn1' @click='shTgEvent(record, 2)' style="background-color: #ed4849;">審核拒絕</button>
						<button class='btn1 btnx' @click='shTgEvent(record , 1)'>審核通過</button>
					</div>
				</div>
			</div>
		<!-- 	<div  class='warp_daochu' v-else>
				<div style="padding: .35rem 0;margin-left: auto;">
					<button class='btn1 btnx'  @click='savefn'>保存</button>
					<button class='btn1 ' @click='$emit("child","handhome2")' style="background-color: #f48d28;">下一页</button>
				</div>
			</div> -->
		</div>
		<div class='warp_daochu' v-else>
			<div style="padding: .35rem 0;margin-left: auto;">
				<button class='btn1 btnx'  @click='savefn'>保存</button>
				<button class='btn1 ' style="background-color: #f48d28;" @click='handokfn' v-if='form.status_cn == 0'>提交</button>
				<button class='btn1 ' style="background-color: #f48d28;" @click='gofn' v-else>下一頁</button>
			</div>
		</div>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';

	export default {
		props: ['record', 'forms'],
		data() {
			return {
				shKhadmin1Bol: false,
				industryArr:[
					{
						id:1,
						industry:'行业1',
						industry_en:"industry1"
					},
										{
						id:2,
						industry:'行业2',
						industry_en:"industry2"
					},
										{
						id:3,
						industry:'行业3',
						industry_en:"industry3"
					}
				],
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				rules: {
					cn_planned_company_name_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_company_name_en: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_industry_name_cn: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					cn_planned_industry_name_en: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					plates_cn: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					status_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					delivery_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					linkaddress: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				england: 'cn',
				admintypeArr: [{
									text: '處理中',
										entext:'Processing',
										value: '0'
									},
									{
										text: '認購中',
										entext:'Subscribing',
										value: '1'
									},
									{
										text: '待上市',
										entext:'Planned IPO',
										value: '2'
									},
									{
										text: '已上市',
										entext:'Listed IPO',
										value: '3'
									},
									{
									   text: '已除牌',
										entext:'Delisted',
										value: '4'
									},
									{
									    text: '已失效',
										entext:'Expired',
										value: '5'
									}	
									],
				admintypeArrs: [{
						text: '主板',
						entext: 'Mainboard',
						value: 0
					},
					{
						text: '創業板',
						entext: 'GEM board',
						value: 1
					},
				],
				remark: '',
				form: {
					"pricelist": [{
						"pricekey": "",
						"priceval": ""
					}, ],
					info_en:'',
					stockname_en: '', //股票名稱英文
					cn_planned_company_name_en: '', //公司名稱英文 
					cn_planned_industry_name_en: '', //行業英文 
					"stockcode": "", //輸入股票代碼
					"stockname": "", //輸入股票名稱
					"offer_price_l": '', //招股價起始值
					"offer_price_h": '', //招股價最大值
					"pergshu": '', //每手股數
					"application_open": "", //認購日期起始
					"application_close": "", //認購日期截止
					"listingdate": "", //上市日期
					"entryfee": '', //入場費
					"cn_planned_company_name_cn": "", //公司名稱
					"cn_planned_industry_name_cn": "", //上市行業
					"status_cn": "", //上市狀態   已上市 （股票名称 股票代码）
					"plates_cn": "", //上市板塊
					"delivery_date": "", //遞表日期
					"baojianr": "", //保薦機構
					"anpantime": "", //暗盤時間
					"multiple": '', //認購倍數
					info: '',
					linkaddress: '',
					pricefileid: '',
					loan_ratio: '', // 比率
					loan_days: '', // 日數
					gain: '', // 利息
					// "adminid": "", // 錄入人唯一標識
				},
			}
		},
		beforeMount(){
			this.$ajax({
				method: 'post',
				url: this.$api.getParamList,
				data: {"type":"industrys",'searchstr':''}
			}).then(res => {
				if (res.data.qmiscode === 1000) {
					this.industryArr = res.data.result;
				} else {
					this.$message.warning(res.data.qmismsg)
				}
			})
		},
		mounted() {
			// this.form = JSON.parse(JSON.stringify(this.forms))
		},
		watch: {
			forms: {
				immediate: true,
				deep: true,
				handler(ev) {
					this.form = JSON.parse(JSON.stringify(this.forms))
				}
			}
		},
		methods: {
			gofn() {
				this.$refs.ruleForm.validate(valid => {
				if (valid) {
						this.$emit("child","handhome2")
					}
				})
			},
			handokfn(){
				this.$refs.ruleForm.validate(valid => {
				if (valid) {
						this.form.token = this.$store.state.token
						this.$ajax({
							method: 'post',
							url: this.$api.newIpoSelling,
							headers: {
								token: this.$store.state.token,
							},
							data: this.form
						}).then(res => {
							console.log(res.data)
							if (res.data.qmiscode == 1000) {
								App.oTool.successT();
								this.$emit('child')
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					}
				})
			},
			savefn() {
				this.$refs.ruleForm.validate(valid => {
				if (valid) {
						this.$ajax({
							method: 'post',
							url: this.$api.newIpoSellingAudit,
							data: this.form
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								this.$message.success(res.data.qmismsg)
								this.$emit('child','save',res.data.id)
							} else {
								this.$message.warning(res.data.qmismsg)
							}
						})
					}
				})
			},
			handselefn(val, ruleForm) {
				this.$emit('childs')
				// if (val == 0) {
				// 	this.rules = this.zerorules
				// } else if (val == 1 || val == 2) {
				// 	this.rules = this.allrules
				// } else if (val == 3) {
				// 	this.rules = this.stockrules
				// }
				// let obj = JSON.parse(JSON.stringify(this.form))
				// this.$refs[ruleForm].resetFields();
				// this.form = obj
			},
			compareDate(dateTime1, dateTime2) {
				var formatDate1 = new Date(this.form[dateTime1])
				var formatDate2 = new Date(this.form[dateTime2])
				if (formatDate1 > formatDate2) {
					this.form[dateTime1] = '';
				}
			},
			handback(val) {
				this.form[val] = this.form[val] ? App.oDate.secsTime3(this.form[val]._d) : ''
				//（遞表日期）》啟示認購日期 》 終止認購日期》（上市日期）
				if (val == 'application_close' || val == 'application_open') {
					if (this.form.application_close && this.form.application_open) {
						this.compareDate('application_open', 'application_close')
					}
				}
				//遞表日期》上市日期
				if (val == 'delivery_date' || val == 'listingdate') {
					if (this.form.delivery_date && this.form.listingdate) {
						this.compareDate('delivery_date', 'listingdate')
					}
				}
				//（遞表日期）》啟示認購日期
				if (val == 'delivery_date' || val == 'application_open') {
					if (this.form.delivery_date && this.form.application_open) {
						this.compareDate('delivery_date', 'application_open')
					}
				}
				//終止認購日期》（上市日期）
				if (val == 'application_close' || val == 'listingdate') {
					if (this.form.application_close && this.form.listingdate) {
						this.compareDate('application_close', 'listingdate')
					}
				}


				//暗盤日期 獲取上市日期前一天
				if (this.form.listingdate) {
					// this.form.anpantime = this.getNextDate(this.form.listingdate, -1)
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'application_close') {
					if (this.form.anpantime && this.form.application_close) {
						this.compareDate('application_close', 'anpantime')
					}
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'delivery_date') {
					if (this.form.anpantime && this.form.delivery_date) {
						this.compareDate('delivery_date', 'anpantime')
					}
				}
			},
			handen() {
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.replace(/<\/?.+?>/g, "");
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.replace(/[\r\n]/g, "");
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.replace(/ +/g, ' ');
				this.form.cn_planned_company_name_en = this.form.cn_planned_company_name_en.trim()
			},
			handcn() {
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/<\/?.+?>/g, "");
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/[\r\n]/g, "");
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.replace(/ +/g, ' ');
				this.form.cn_planned_company_name_cn = this.form.cn_planned_company_name_cn.trim()
			},
			//禁止選擇
			deliveryDate(current) {
				return current && current > new Date(this.form.listingdate)
			},
			handkong() {
				this.form.info = this.form.info.replace(/<\/?.+?>/g, "");
				this.form.info = this.form.info.replace(/[\r\n]/g, "");
				this.form.info = this.form.info.replace(/ +/g, ' ');
				this.form.info = this.form.info.trim()
			},
			shTgEvent(record, type) { //1通過  //2拒絕
				if (!this.remark) {
					if (type == 1) {
						this.remark = '資料齊全'
					} else if (type == 2 && !this.remark) {
						App.oTool.warningT('請填寫備註信息');
						return
					}
				}

				this.$ajax({
					method: 'post',
					url: this.$api.ipoAdmin,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"iposelling_id": this.form.iposelling_id,
						token: this.$store.state.token,
						"handle": type,
						remark: this.remark
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child');
						this.shShowBol = false;
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			industryCNChanged(obj){
				var item = this.industryArr.find((p)=>{
					if(p.industry == obj){
						return p;
					}
				}
				)
				this.form.cn_planned_industry_name_en = item.industry_en;
			},
			industryENChanged(obj){
				var item = this.industryArr.find((p)=>{
					if(p.industry_en == obj){
						return p;
					}
				}
				)
				this.form.cn_planned_industry_name_cn = item.industry;
			}
		}
	}
</script>
<style scoped>
	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn {
		background-color: #fff;
		padding: 0.7rem 0;
		border-radius: 4px;
		overflow: hidden;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList {
		padding: 0.5rem 0;
		border-bottom: 1px #f3f3f3 solid;
		display: flex;
		align-items: flex-start;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList:last-child {
		border: none;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .left {
		width: 24%;
		color: #000;
		font-size: 0.8rem;
	}

	#handitemedit1 .center {
		/* height: 1.7rem;
		    line-height: 1.7rem; */
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .center {
		font-size: 0.8rem;
		width: calc(70% - 2rem);
		color: #000;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList img {
		width: 1.2rem;
		height: 1.2rem;
		margin: auto 0;
		margin-left: auto;
	}
</style>
